import { all_routes } from "../../../../feature-module/router/all_routes";

export const header = [
  // MENU HEADER Cho Homepage
  // {
  //   tittle: "Home",
  //   base: "home",
  //   showAsTab: false,
  //   separateRoute: true,
  //   menu: [
  //     {
  //       menuValue: "Home 1",
  //       img: "assets/img/home/home-01.jpg",
  //       route: all_routes.homeone,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       menuValue: "Home 2",
  //       img: "assets/img/home/home-02.jpg",
  //       route: all_routes.hometwo,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       menuValue: "Home 3",
  //       img: "assets/img/home/home-03.jpg",
  //       route: all_routes.homethree,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       menuValue: "Home 4",
  //       img: "assets/img/home/home-04.jpg",
  //       route: all_routes.homefour,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       menuValue: "Home 5",
  //       img: "assets/img/home/home-05.jpg",
  //       route: all_routes.homefive,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       menuValue: "Home 6",
  //       img: "assets/img/home/home-06.jpg",
  //       route: all_routes.homesix,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //   ],
  // },
  // {
  //   key: "courses",
  //   tittle: "Courses",
  //   route: all_routes.studentCourses,
  //   base: "course",
  //   showAsTab: false,
  //   separateRoute: false,
  //   menu: [],
  // },
  {
    key: "studentDashboard",
    menuValue: "headerMenu.studentDashboard",
    route: all_routes.studentDashboard,
  },
  
  {
    key: "enrolledCourses",
    menuValue: "headerMenu.enrolledCourses",
    route: all_routes.studentCourses,
  },
  // {
  //   key: "certificates",
  //   menuValue: "headerMenu.certificates",
  //   route: all_routes.studentCertificates,
  // },
  {
    key: "forum",
    menuValue: "headerMenu.forum",
    route: all_routes.studentForum,
  },
  {
    key: "quizAttempts",
    menuValue: "headerMenu.quizAttempts",
    route: all_routes.studentQuiz,
  },
  {
    key: "progress",
    menuValue: "headerMenu.progress",
    route: all_routes.studentProgress,
  },
  {
    key: "profile",
    menuValue: "headerMenu.profile",
    route: all_routes.studentProfile,
  },
  // {
  //   key: "messages",
  //   menuValue: "headerMenu.messages",
  //   route: all_routes.studentMessage,
  // },
  // {
  //   key: "contactSupport",
  //   menuValue: "headerMenu.contactSupport",
  //   route: all_routes.studentTickets,
  // },
  // {
  //   key: "settings",
  //   menuValue: "headerMenu.settings",
  //   route: all_routes.studentSettings,
  // },

  // {
  //   key: "pages",
  //   tittle: "Pages",
  //   showAsTab: false,
  //   separateRoute: false,
  //   base: "pages",
  //   menu: [
  //     {
  //       key: "aboutUs",
  //       menuValue: "About Us",
  //       route: all_routes.about_us,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       key: "contactUs",
  //       menuValue: "Contact Us",
  //       route: all_routes.contactUs,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       key: "notification",
  //       menuValue: "Notification",
  //       route: all_routes.notification,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       key: "faq",
  //       menuValue: "FAQ",
  //       route: all_routes.FAQ,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       key: "termsConditions",
  //       menuValue: "Terms & Conditions",
  //       route: all_routes.termsConditions,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //     {
  //       key: "privacyPolicy",
  //       menuValue: "Privacy Policy",
  //       route: all_routes.privacyPolicy,
  //       hasSubRoute: false,
  //       showSubRoute: false,
  //       subMenus: [],
  //     },
  //   ],
  // },
  // {
  //   key: "blog",
  //   tittle: "Blog",
  //   route: all_routes.blogGrid3,
  //   showAsTab: false,
  //   separateRoute: false,
  //   base: "blog",
  //   menu: [],
  // },
];
